module.exports = __webpack_public_path__ + "static/media/success.fc77d317.svg";